var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9039 0H6.4247C2.87466 0 0 3.04894 0 6.80736V18.7951C0 18.893 0.00288304 18.9878 0.00576925 19.0857C0.00288304 19.1346 0 19.1805 0 19.2325V30.1805C0 31.6882 1.16603 32.9512 2.58604 32.8716C3.80979 32.8013 4.81996 31.8074 4.96427 30.5047L5.31928 27.2998C5.46936 25.9481 6.55169 24.9267 7.83606 24.9267C13.62 24.9297 28.5417 24.9297 28.5417 24.9297C31.7368 24.9297 34.3286 22.1835 34.3286 18.7982V6.8104C34.3286 3.04893 31.451 0 27.9039 0Z",
    fill: "url(#paint0_linear_26179_60842)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26179_60842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4582 14.5146H34.2131C37.4081 14.5146 39.9999 17.2608 39.9999 20.6462V27.7838C39.9999 27.8817 39.997 27.9765 39.9941 28.0743C39.997 28.1233 39.9999 28.1691 39.9999 28.2211V37.3068C39.9999 38.8572 38.7992 40.1202 37.3388 39.9918C36.1497 39.8878 35.1742 38.9092 35.0327 37.6309C34.6749 35.4811 32.9114 33.9153 30.8535 33.9153C24.4057 33.9184 11.4554 33.9184 11.4553 33.9184C11.4553 33.9184 11.4553 33.9184 11.4553 33.9184C8.26028 33.9184 5.66846 31.1722 5.66846 27.7869C5.66846 27.7869 5.66846 23.2303 5.66846 20.6492C5.67134 17.2608 8.26316 14.5146 11.4582 14.5146Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6156 27.3029C16.1682 27.3029 17.4268 25.9693 17.4268 24.3243C17.4268 22.6793 16.1682 21.3457 14.6156 21.3457C13.063 21.3457 11.8044 22.6793 11.8044 24.3243C11.8044 25.9693 13.063 27.3029 14.6156 27.3029Z",
    fill: "url(#paint1_linear_26179_60842)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.475 27.3029C24.0276 27.3029 25.2862 25.9693 25.2862 24.3243C25.2862 22.6793 24.0276 21.3457 22.475 21.3457C20.9224 21.3457 19.6638 22.6793 19.6638 24.3243C19.6638 25.9693 20.9224 27.3029 22.475 27.3029Z",
    fill: "url(#paint2_linear_26179_60842)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2304 27.3029C31.7829 27.3029 33.0415 25.9693 33.0415 24.3243C33.0415 22.6793 31.7829 21.3457 30.2304 21.3457C28.6778 21.3457 27.4192 22.6793 27.4192 24.3243C27.4192 25.9693 28.6778 27.3029 30.2304 27.3029Z",
    fill: "url(#paint3_linear_26179_60842)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26179_60842",
    x: -3.14615,
    y: 5.70004,
    width: 51.9608,
    height: 43.1155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26179_60842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26179_60842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26179_60842",
    x1: -0.715178,
    y1: -3.93818,
    x2: 32.4831,
    y2: 34.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26179_60842",
    x1: 11.8044,
    y1: 21.8111,
    x2: 17.4412,
    y2: 26.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26179_60842",
    x1: 19.6638,
    y1: 21.8111,
    x2: 25.3006,
    y2: 26.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26179_60842",
    x1: 27.4192,
    y1: 21.8111,
    x2: 33.056,
    y2: 26.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectOther);
export default __webpack_public_path__ + "static/media/select-other.3214fce44a3cfa29f8035cff1f46d929.svg";
export { ForwardRef as ReactComponent };